// Src: https://www.npmjs.com/package/react-styled-flexboxgrid
//
export const FlexboxGrid = {
  gutterWidth: window.innerWidth >= 768 ? 2 : 1, // rem
  outerMargin: 0, // rem
}